import { render, staticRenderFns } from "./NumberField.vue?vue&type=template&id=65a0d5cb&scoped=true&"
import script from "./NumberField.vue?vue&type=script&lang=js&"
export * from "./NumberField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a0d5cb",
  null
  
)

export default component.exports